import { useRef } from 'react';
import { use_effect } from './use_effect';

export function use_ref_updating<T>(value: T) {
  const ref = useRef<T>(value);

  /*
   * EFFECTS
   */
  use_effect(() => void (ref.current = value), [value]);

  return ref;
}
